module.exports = __webpack_public_path__ + "img/Bouclier10.9ef0c779.png";